// TODO revisar con Bryan si estan bien la id de los roles
export const USER_ROLES = {
  admin: "01549060-1c43-4884-ba26-961f88f7482e",
  supervisor: "01549060-1c43-4884-ba26-961f88f7482e",
  operator: "bdfa1e62-f284-4a7b-81de-34d627b4abe9",
};
